<template>
  <ul class="breadcrumb">
    <li v-if="itemCo.name.length > 1" class="breadcrumb-item">
      Coordinator:
      <router-link :to="itemCo.to">{{itemCo.name}}</router-link>
    </li>
    <li v-if="itemTr.name.length > 1" class="breadcrumb-item">
      Trainer:
      <router-link :to="itemTr.to">{{itemTr.name}}</router-link>
    </li>
    <li v-if="itemGr.name.length > 1" class="breadcrumb-item">
      Group:
      <router-link :to="itemGr.to">{{itemGr.name}}</router-link>
    </li>
    <li v-if="itemSc.name.length > 1" class="breadcrumb-item">
      School:
      <router-link :to="itemSc.to">{{itemSc.name}}</router-link>
    </li>
    <li v-if="itemTe.name.length > 1" class="breadcrumb-item">
      Teacher:
      <router-link :to="itemTe.to">{{itemTe.name}}</router-link>
    </li>
  </ul>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapGetters } from "vuex";
import CrumbService from "@/services/CrumbService";
import router from "@/router";

export default {
  name: "Breadcrumb",
  props: ["level"],
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      FILL_LEVELS: "crumb/FILL_LEVELS",
      RESET_CRUMB: "crumb/RESET_CRUMB_STATE"
    })
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
      getTrainerUuid: "auth/getTrainerUuid",
      getCoordinatorUuid: "auth/getCoordinatorUuid"
    }),
    currentId() {
      return router.currentRoute.params.id;
    },
    coordinatorCheck: {
      get() {
        return this.$store.state.crumb.coordinator.name;
      }
    },
    trainerCheck: {
      get() {
        return this.$store.state.crumb.trainer.name;
      }
    },
    groupCheck: {
      get() {
        return this.$store.state.crumb.group.name;
      }
    },
    schoolCheck: {
      get() {
        return this.$store.state.crumb.school.name;
      }
    },
    teacherCheck: {
      get() {
        return this.$store.state.crumb.teacher.name;
      }
    },
    itemCo: {
      get() {
        return {
          name: this.$store.state.crumb.coordinator.name,
          to: {
            name: "EditCoordinator",
            params: { id: this.$store.state.crumb.coordinator.uuid }
          }
        };
      }
    },
    itemTr: {
      get() {
        return {
          name: this.$store.state.crumb.trainer.name,
          to: {
            name: "EditTrainer",
            params: { id: this.$store.state.crumb.trainer.uuid }
          }
        };
      }
    },
    itemGr: {
      get() {
        return {
          name: this.$store.state.crumb.group.name,
          to: {
            name: "EditGroup",
            params: { id: this.$store.state.crumb.group.uuid }
          }
        };
      }
    },
    itemSc: {
      get() {
        return {
          name: this.$store.state.crumb.school.name,
          to: {
            name: "EditSchool",
            params: { id: this.$store.state.crumb.school.uuid }
          }
        };
      }
    },
    itemTe: {
      get() {
        return {
          name: this.$store.state.crumb.teacher.name,
          to: {
            name: "EditTeacher",
            params: { id: this.$store.state.crumb.teacher.uuid }
          }
        };
      }
    },
    crumbItems: {
      get() {
        const items = [];
        if (
          ["trainer", "group", "teacher", "student"].indexOf(this.level) >= 0
        ) {
          items.push({
            name: "Coordinator: " + this.$store.state.crumb.coordinator.name,
            to: {
              name: "EditCoordinator",
              params: { id: this.$store.state.crumb.coordinator.uuid }
            }
          });
        }
        if (["group", "teacher", "student"].indexOf(this.level) >= 0) {
          items.push({
            name: "Trainer: " + this.$store.state.crumb.trainer.name,
            to: {
              name: "EditTrainer",
              params: { id: this.$store.state.crumb.trainer.uuid }
            }
          });
        }
        if (["teacher", "student"].indexOf(this.level) >= 0) {
          items.push({
            name: "Group: " + this.$store.state.crumb.group.name,
            to: {
              name: "EditGroup",
              params: { id: this.$store.state.crumb.group.uuid }
            }
          });
          items.push({
            name: "School: " + this.$store.state.crumb.school.name,
            to: {
              name: "EditSchool",
              params: { id: this.$store.state.crumb.school.uuid }
            }
          });
        }
        if (["student"].indexOf(this.level) >= 0) {
          items.push({
            name: "Teacher: " + this.$store.state.crumb.teacher.name,
            to: {
              name: "EditTeacher",
              params: { id: this.$store.state.crumb.teacher.uuid }
            }
          });
        }
        console.log("crumbItems called, items: ", items);
        return items;
      }
    }
  },
  watch: {
    coordinatorCheck(val) {
      console.log("coord change");
      this.itemCo;
    },
    trainerCheck() {
      console.log("trainer change");
      this.itemTr;
    },
    groupCheck() {
      console.log("group change");
      this.itemGr;
    },
    schoolCheck() {
      console.log("school change");
      this.itemSc;
    },
    teacherCheck() {
      this.itemTe;
    }
  },
  created() {
    this.RESET_CRUMB();
    this.FILL_LEVELS(this.level);
  }
};
</script>

<style scoped>
li {
  list-style-type: none;
}

nav {
  background-color: #b4d7df;
}

#dashboards,
#add-data,
#view-edit {
  font-size: 20px;
}
#login,
#logout {
  margin: 0.5%;
}

#signoutFlash,
#signinFlash,
#errorFlash,
#authFlash,
#adminFlash {
  text-align: center;
  display: inline-block;
}

nav > * {
  color: #31493e;
}
.email-form {
  width: 25%;
}
</style>
